import { useEffect, useState } from 'react'
import { WsKbd } from './workspace'

/**
 * The strip along the foot of the workspace.
 *
 * It used to repeat what the panes already say — a character count that sits
 * above the input, the elapsed time that sits beside the result, the audience
 * form that the audience control itself shows — behind a "Connected" light
 * that was hardcoded to say Connected. What is left is the two things this
 * row is the only place for: which model is translating, and the shortcuts.
 * The connection light now earns its place by appearing only when the
 * browser says the network is gone, which is the one time it is news.
 */
export function StatusBar({ modelLabel }: { modelLabel: string }) {
  const [offline, setOffline] = useState(
    () => typeof navigator !== 'undefined' && navigator.onLine === false,
  )

  useEffect(() => {
    const update = () => setOffline(navigator.onLine === false)
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
    return () => {
      window.removeEventListener('online', update)
      window.removeEventListener('offline', update)
    }
  }, [])

  return (
    <div
      className="hidden md:flex shrink-0 items-center gap-[18px] h-7 px-3.5 border-t border-app font-mono"
      style={{ background: 'var(--cream-2)', fontSize: 11.5, color: 'var(--muted)' }}
    >
      {offline && (
        <span className="inline-flex items-center gap-1.5" style={{ color: 'var(--err)' }}>
          <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ background: 'var(--err)' }} />
          Offline
        </span>
      )}
      <span>{modelLabel}</span>
      <div className="flex-1" />
      <span className="inline-flex items-center gap-1.5"><WsKbd>⌘K</WsKbd> commands</span>
      <span className="inline-flex items-center gap-1.5"><WsKbd>⌘L</WsKbd> listen</span>
      <span className="inline-flex items-center gap-1.5"><WsKbd>⌘S</WsKbd> save</span>
    </div>
  )
}
